import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { Store } from '../_core/types/Store';
import useApiStore from '../apiStore/useApiStore';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import useProgressStore from '../progressStore/useProgressStore';
import useTaskStore from '../taskStore/useTaskStore';
import useUserStore from '../userStore/useUserStore';
import { dashboardStore } from './dashboardStore';
import { DashboardState } from './types/DashboardState';

const useDashboardStore: Store<DashboardState> = createStore({
  creator: dashboardStore({
    useApiStore: lazyDependency(() => useApiStore),
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    useProgressStore: lazyDependency(() => useProgressStore),
    useTaskStore: lazyDependency(() => useTaskStore),
    useUserStore: lazyDependency(() => useUserStore),
  }),
  id: 'dashboard',
  middlewares: {
    devtools: true,
  },
});

export default useDashboardStore;
